import { TelephoneNumber } from './telephone-number';
import { ModelObject } from './model-object';

export interface Person extends ModelObject<number> {
  surname: string;
  givenNames: string;
  mail?: string;
  telephoneNumbers?: TelephoneNumber[];
}

export const personNameSelector = (person: Person) =>
  (person && `${person.givenNames} ${person.surname && person.surname.toUpperCase()}`) ?? 'New';
